<app-maintenance *ngIf="maintenanceOn; else appContent"></app-maintenance>
<ng-template #appContent>
  <output *ngIf="sharedService.isLoading | async" aria-label="Loading">
    <div class="sdps-spinner-container sdps-spinner-container--page">
      <div class="sdps-spinner sdps-flex-center">
        <span class="sch sch-spinner sch-spin-stepped" aria-hidden="true"></span>
      </div>
    </div>
  </output>
  <main>
    <router-outlet></router-outlet>
  </main>
  <app-global-timeout *ngIf="!sharedService.isInternalApp()"></app-global-timeout>
</ng-template>
